import { Chip } from '@mui/material';
import { getSemaforoColor, SemaforoColor } from '../utils/semaforo';

const MUI_COLOR: Record<SemaforoColor, 'success' | 'warning' | 'error' | 'default'> = {
    verde: 'success',
    amarillo: 'warning',
    rojo: 'error',
    neutro: 'default'
};

const LABEL: Record<SemaforoColor, string> = {
    verde: 'SRT: En plazo',
    amarillo: 'SRT: Por vencer',
    rojo: 'SRT: Vencido',
    neutro: 'SRT: Sin plazo'
};

interface SemaforoSRTProps {
    fechaVencimientoSRT?: string | null;
    fechaPresentacionVisita?: string | null;
    esPreventor: boolean;
}

export default function SemaforoSRT({ fechaVencimientoSRT, fechaPresentacionVisita, esPreventor }: SemaforoSRTProps) {
    if (esPreventor) return null;

    const color = getSemaforoColor(fechaVencimientoSRT, fechaPresentacionVisita);

    return (
        <Chip
            label={LABEL[color]}
            color={MUI_COLOR[color]}
            size="small"
            sx={{ height: 22, borderRadius: 1, fontSize: 11, fontWeight: 700 }}
        />
    );
}
